var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EC5C52",
    stroke: "#EC5C52",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71429 17.6667C8.71429 18.4 9.35714 19 10.1429 19H15.8571C16.6429 19 17.2857 18.4 17.2857 17.6667V9.66667H8.71429V17.6667ZM10.4714 12.92L11.4786 11.98L13 13.3933L14.5143 11.98L15.5214 12.92L14.0071 14.3333L15.5214 15.7467L14.5143 16.6867L13 15.2733L11.4857 16.6867L10.4786 15.7467L11.9929 14.3333L10.4714 12.92ZM15.5 7.66667L14.7857 7H11.2143L10.5 7.66667H8V9H18V7.66667H15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteHover);
export default __webpack_public_path__ + "static/media/deleteHover.aa457aa38dada3a3dfbe2104ace1ce55.svg";
export { ForwardRef as ReactComponent };